import CommunitySettings from 'routes/CommunitySettings/CommunitySettings';

export default CommunitySettings;
